import { coreUsersByIdNotificationPreferencesGetAsyncSlice } from './get';
import { CoreUsersByIdNotificationPreferencesName } from './name';
import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { PatchUserNotificationPreferencesRequest } from '@api';
import { UserNotificationPreferences } from '@types';

export const coreUsersByIdNotificationsPreferencesUpdateSyncSlice = createUpdateSyncSlice<
	typeof CoreUsersByIdNotificationPreferencesName,
	UserNotificationPreferences,
	PatchUserNotificationPreferencesRequest
>({
	name: CoreUsersByIdNotificationPreferencesName,
	state: coreUsersByIdNotificationPreferencesGetAsyncSlice.asyncState
});
